import React, { ReactNode, useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const ToastContainer = styled.div`
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: ${(props) => props.justifyContent};
  background-color: #454545;
  padding: 15px 24px;
  border-radius: 36px;
  width: 288px;
  min-height: 51px;
  bottom: 88px;
  left: 50%;
  transform: translateX(-50%);
  box-sizing: border-box;
`;

const ToastMessageText = styled.p`
  font-size: 14px;
  line-height: 21px;
  color: #fff;
  text-overflow: ellipsis;
  white-space: normal;
  overflow: hidden;
  word-wrap: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`;

const SnackBarMessageText = styled.p`
  font-size: 14px;
  line-height: 21px;
  color: #FFF42E;
  max-width: 120px;
  font-weight: bold;
`;

export default function Toast({ message, snackBarOnClickText, snackBarOnClickFunction }): JSX.Element {
  return (
    <ToastContainer justifyContent={snackBarOnClickText ? 'space-between' : 'center'}>
      <ToastMessageText>{message}</ToastMessageText>
      { snackBarOnClickText
        ? (
          <SnackBarMessageText onClick={() => {
            snackBarOnClickFunction();
          }}
          >{snackBarOnClickText}
          </SnackBarMessageText>
        )
        : <></>}
    </ToastContainer>
  );
}

Toast.propTypes = {
  message: PropTypes.string,
  snackBarOnClickText: PropTypes.string,
  snackBarOnClickFunction: PropTypes.func,
};

Toast.defaultProps = {
  message: '',
  snackBarOnClickText: '',
  snackBarOnClickFunction: () => {},
};
